import { NgModule } from '@angular/core';
import { ConnectivityService } from './services/connectivity.service';

@NgModule({
  providers: [ConnectivityService]
})
export class DomainConnectivityModule { }
